<template>
    <main
        class="min-w-0 flex-1 border-t border-taupe-200 lg:flex overflow-y-auto bg-taupe-50"
    >
        <section
            aria-labelledby="primary-heading"
            class="flex h-full min-w-0 flex-1 flex-col lg:order-last pt-6 sm:pt-8 lg:pt-10 xl:max-w-7xl xl:mx-auto w-full"
        >
            <h1 id="primary-heading" class="sr-only">API/MCP Tokens</h1>
            <div class="px-4 sm:px-6 lg:px-8 pb-12 space-y-8">
                <div class="sm:flex sm:items-center sm:justify-between">
                    <div class="sm:flex-auto">
                        <admin-header-tabs current="api-mcp-tokens" />
                    </div>
                </div>

                <management-api-tokens-panel v-if="managementApiEnabled" />
                <personal-access-tokens-panel />
            </div>
        </section>
    </main>
</template>

<script>
import { getFlag } from '@/utils/feature-flags'
import AdminHeaderTabs from '@/screens/_components/admin/HeaderTabs.vue'
import ManagementApiTokensPanel from '@/screens/_components/admin/ManagementApiTokensPanel.vue'
import PersonalAccessTokensPanel from '@/screens/_components/admin/PersonalAccessTokensPanel.vue'

export default {
    name: 'AdminApiMcpTokensScreen',
    components: {
        AdminHeaderTabs,
        ManagementApiTokensPanel,
        PersonalAccessTokensPanel,
    },
    data() {
        return {
            managementApiEnabled: false,
        }
    },
    async mounted() {
        this.managementApiEnabled = await getFlag(
            'enable-management-api',
            false
        )
    },
}
</script>
